module.exports = __webpack_public_path__ + "static/media/2.eb750a31.jpg";